function closePopup() {
    $('#mask').hide();
    $('.window').hide();
    document.getElementById("fileAttachment").innerHTML = "<input type=\"file\" name=\"new_cart_approval_attachment[]\" onchange=\"validateFileInput(this.value)\">";
    $('#addAttachmentLink').attr("disabled", "disabled");
}

function addOne(attachmentHyperlink) {
    if (!$(attachmentHyperlink).attr('disabled')) {
        var datum = new Date();
        var datumInMilliseconds = datum.getMilliseconds();
        var htmlElement = "<p id='p" + datumInMilliseconds + "'><input type=\"file\" id='file" + datumInMilliseconds + "' onchange=\"validateFileInput(this.value)\" \n\\n\ name=\"new_cart_approval_attachment[]\">\n\ \n\
                        <a href=\"#\" onclick=\"removeOne('#p" + datumInMilliseconds + "');return false;\">" + output['t_remove'] + "</a></p>";
        $("#fileAttachment").append(htmlElement);
        $('#dialog').animate({height: '+=50px'}, 500);
        $(attachmentHyperlink).attr("disabled", "disabled");
    } else {
        alert(output['e_no_attachment_selected']);
    }
}

function removeOne(id) {
    $(id).remove();
    $('#dialog').animate({height: '-=15px'}, 500);
    enableLink('addAttachmentLink');
}

function validateFileInput(fileInputValue) {
    if (filetypeOK(fileInputValue)) {
        enableLink('addAttachmentLink');
    } else {
        $('#addAttachmentLink').attr("disabled", "disabled");
    }
    return false;
}

function enableLink(linkId) {
    $('#' + linkId).removeAttr("disabled");
}

function filetypeOK(uploadfile, extArray) {
    if (!extArray)
        extArray = l_user['partner_permit_upload_filetypes'].replace(/\'/g, '').split(',');
    if (extArray.length < 2) {
        return true;
    }
    var allowSubmit = false;
    if (!uploadfile)
        return;
    if (uploadfile.value) {
        uploadfile = uploadfile.value;
    }

    while (uploadfile.indexOf("\\") != -1) {
        uploadfile = uploadfile.slice(uploadfile.indexOf("\\") + 1);
    }
    ext = uploadfile.slice(uploadfile.lastIndexOf(".")).toLowerCase();
    for (var i = 0; i < extArray.length; i++) {
        if (extArray[i] == ext) {
            allowSubmit = true;
            break;
        }
    }
    if (!allowSubmit) {
        alert(output['e_nur_folgende_dateitypen_erlaubt'] + extArray.join(", "));
        return false;
    } else {
        return true;
    }
}
